import { useAppSelector } from "../../store/hooks";
import AppScreenUI from "../ui/AppScreenUI";
import { selectIsAdmin, selectIsRoot } from "../../store/slices/session";
import AuthScreen from "./AuthScreen";
import { ReactNode } from "react";
import RootPage from "./RootPage";

interface AppScreenProps {
	children: ReactNode;
}

export default function AppScreen(props: AppScreenProps) {
	const session = useAppSelector(state => state.session);
	if (!session.authenticated) {
		return <AuthScreen />;
	}

	const isAdmin = selectIsAdmin(session);
	const isRoot = selectIsRoot(session);

	if (isRoot) {
		return <AppScreenUI hideNavigation>
			<RootPage />
		</AppScreenUI>;
	}

	return <AppScreenUI showAdminNavigation={isAdmin}>
		{props.children}
	</AppScreenUI>;
}
